import FourPlayersIntroduction from './twoPlayersPs'

export default FourPlayersIntroduction